import { FC, Fragment, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCartFlatbedSuitcase,
  faPersonWalkingLuggage,
  faSuitcaseRolling,
} from '@fortawesome/free-solid-svg-icons';
import TicketBaggagePopup from './TicketBaggagePopup';
import { useTranslation } from 'react-i18next';
import { DealBaggage } from 'ts/package/interfaces/PackageDetails';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface TicketBaggagePacProps {
  dealBaggage: DealBaggage;
  shortMode?: boolean;
}
const TicketBaggagePac: FC<TicketBaggagePacProps> = (props) => {
  const {
    unitHandbag,
    unitTrolley,
    unitBaggage,
    maxWeightHandbag,
    maxWeightTrolley,
    maxWeightBaggage,
  } = props.dealBaggage;
  const [isShownPopup, setIsShownPopup] = useState(false);
  const { t } = useTranslation();

  return (
    <Fragment>
      {unitHandbag !== -1 && (
        <div
          className="mr-10 position-relative"
          onMouseEnter={() => setIsShownPopup(true)}
          onMouseLeave={() => setIsShownPopup(false)}
        >
          <FontAwesomeIcon
            icon={faSuitcaseRolling}
            className={'cur-poi ' + (unitHandbag === 0 ? 'color-danger' : 'text-success')}
          />
          {!props.shortMode && (
            <span className="ml-5">
              {unitHandbag === 0 ? (
                <span className="color-danger">{t('flight.handbag_excluded')}</span>
              ) : (
                <span className="text-success">
                  {t('flight.handbag_included')} {maxWeightHandbag}
                  {t('kg')}
                </span>
              )}
            </span>
          )}

          {isShownPopup && <TicketBaggagePopup bag={props.dealBaggage} />}
        </div>
      )}

      {unitTrolley !== -1 && (
        <span
          className="mr-10"
          onMouseEnter={() => setIsShownPopup(true)}
          onMouseLeave={() => setIsShownPopup(false)}
        >
          <FontAwesomeIcon
            icon={faPersonWalkingLuggage}
            className={'cur-poi ' + (unitTrolley === 0 ? 'color-danger' : 'text-success')}
          />
          {!props.shortMode && (
            <span className="ml-5">
              {unitTrolley === 0 ? (
                <span className="color-danger">{t('flight.trolley_excluded')}</span>
              ) : (
                <span className="text-success">
                  {t('flight.trolley_included')}

                  {!!maxWeightTrolley && (
                    <span>
                      {maxWeightTrolley} {t('kg')}
                    </span>
                  )}
                </span>
              )}
            </span>
          )}
        </span>
      )}
      {unitBaggage !== -1 && (
        <div
          className="mr-10"
          onMouseEnter={() => setIsShownPopup(true)}
          onMouseLeave={() => setIsShownPopup(false)}
        >
          <FontAwesomeIcon
            icon={faCartFlatbedSuitcase}
            className={'cur-poi ' + (unitBaggage === 0 ? 'color-danger' : 'text-success')}
          />
          {!props.shortMode && (
            <span className="ml-5">
              {unitBaggage === 0 ? (
                <span className="color-danger">{t('flight.bag_excluded')}</span>
              ) : (
                <span className="text-success">
                  {t('flight.bag_included')}
                  {!!maxWeightBaggage && (
                    <span>
                      {maxWeightBaggage} {t('kg')}{' '}
                    </span>
                  )}
                </span>
              )}
            </span>
          )}
        </div>
      )}
    </Fragment>
  );
};
export default withErrorBoundary(TicketBaggagePac, 'TicketBaggagePac');
